import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {MatTable, MatTableModule} from "@angular/material/table";
import {PersonsService} from "../../core/modules/openapi";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatDialogRef} from "@angular/material/dialog";
import {TableItem} from "../applications/applications-data-source";
import {PersonsFilter, PersonsTableDataSource} from "./persons-data-source";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-client-search',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    NgForOf
  ],
  templateUrl: './client-search.component.html',
  standalone: true,
  styleUrl: './client-search.component.sass'
})
export class ClientSearchComponent implements OnInit, AfterViewInit {
  subjects: any[] = [
    {id: "CLIENT_ID", description: "Número de identificación igual a"},
    {id: "FIRST_NAME", description: "Nombre contiene"}];
  displayedColumns = ['identificationNumber', 'personName', 'isNaturalPerson'];
  message: String = "No se encontraron coincidencias";
  dataSource: PersonsTableDataSource;

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatTable) table!: MatTable<TableItem>;
  @Output() selectedUser = new EventEmitter();
  filter = new PersonsFilter();

  group: FormGroup = new FormGroup({
    subject: new FormControl("CLIENT_ID", [Validators.required]),
    searchString: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(30)])
  });

  constructor(public dialogRef: MatDialogRef<ClientSearchComponent>, private service: PersonsService) {
    this.dataSource = new PersonsTableDataSource(service);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
    this.dataSource.filter = this.filter;
  }

  onSubmit() {

    let subject = this.group.get('subject')?.value;
    let searchString = this.group.get('searchString')?.value;

    this.filter.clientId = subject === 'CLIENT_ID' ? searchString : undefined;
    this.filter.firstName = subject === 'FIRST_NAME' ? searchString : undefined;
    this.filter.lastName = subject === 'LAST_NAME' ? searchString : undefined;
    this.filter.updated.emit();
  }

  // sendUser(userId) {
  //   this.selectedUser.emit(userId);
  //   this.onClose();

  // }

  onClose(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }
}
